var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-0"},[_c('img',{staticClass:"fluid-img",attrs:{"src":require("../assets/eMobile.png"),"alt":"eParaksts logo"}}),_c('e-button',{staticClass:"mt-4",attrs:{"block":true,"href":"/e-paraksts","variant":"primary","size":"large","large":""}},[_vm._v(" "+_vm._s(_vm.$t('password_login.login'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }